import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import Configs from "../../Assets/editable-stuff/configurations.json";
import { scroller } from 'react-scroll';
import Seo from "../Seo";

const scrollFunc = (e) => {
  scroller.scrollTo(e, {
    duration: 1400,
    delay: 0,
    offset: 25,
    smooth: 'easeInOutQuart'
  })
}

const AutomationHeader = () => {
  const icons = Configs.icons;

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];
    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const automationFeatures = [
    { title: "Save Time", desc: "Automate repetitive tasks", icon: "⏱️" },
    { title: "Reduce Errors", desc: "Consistent, accurate results", icon: "✓" },
    { title: "Scale Fast", desc: "Grow without limits", icon: "📈" }
  ];
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Business Automation and App Integrations",
    serviceType: "Workflow automation, app integration, and business process automation",
    provider: {
      "@type": "LocalBusiness",
      name: "NeedForGeeks",
      url: "https://www.needforgeeks.com",
    },
    areaServed: {
      "@type": "City",
      name: "New York",
    },
    url: "https://www.needforgeeks.com/automation",
    description:
      "NeedForGeeks connects business tools like Slack, Google Workspace, QuickBooks, and spreadsheets to reduce repetitive work for New York businesses.",
  };

  return (
    <div>
      <Seo
        title="Business Automation & App Integration in New York | NeedForGeeks"
        description="Business automation from NeedForGeeks: connect the apps you already use — Slack, Google Workspace, QuickBooks, and more — to cut manual work in New York."
        path="/automation"
        keywords="business automation New York, workflow automation New York, app integrations New York, QuickBooks automation New York, Slack automation New York"
        structuredData={structuredData}
      />

      <div className="hero-modern hero-automation">
        {/* Left Content Side */}
        <div className="hero-content-side">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Workflow Automation
          </div>

          <h1 className="hero-title-modern">Automation</h1>

          <div className="hero-typing">
            <Typist
              cursor={{ show: true, blink: true, element: '|' }}
              avgTypingDelay={30}
            >
              Work smarter, not harder
            </Typist>
          </div>

          <p className="hero-description">
            Easy automation for busy people. Our Geeks move info between your web apps automatically, so you can focus on your most important work.
          </p>

          <div className="hero-social-row">
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                className="hero-social-link"
              >
                <i
                  className={`fab ${icon.image} fa-lg ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div className="hero-services-side">
          <div className="automation-features-grid">
            {automationFeatures.map((feature, index) => (
              <div
                key={index}
                className="automation-feature-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <span className="feature-icon-large">{feature.icon}</span>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>

          <div className="hero-nav-cards">
            <Link to="/" className="nav-card-mini">
              <span>← Home</span>
            </Link>
            <Link to="/it" className="nav-card-mini">
              <span>IT Services →</span>
            </Link>
            <Link to="/web-app" className="nav-card-mini">
              <span>Web & Apps →</span>
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <IconButton
          onClick={() => scrollFunc("automationServices")}
          className="scroll-indicator"
        >
          <ExpandMoreOutlinedIcon style={{ color: "white", fontSize: "32px" }} />
        </IconButton>

        {/* Background Elements */}
        <div className="hero-bg-gradient"></div>
        <div className="hero-bg-orb hero-bg-orb-1"></div>
        <div className="hero-bg-orb hero-bg-orb-2"></div>
      </div>
    </div>
  );
};

export default AutomationHeader;
